import { lazy } from 'react'

import { ROUTES } from './paths'
import { TYPES_USER_ROLES } from 'utils/constants'
import CourseForm from 'pages/CourseForm'
import SelectGroup from 'pages/SelectGroup'

export const allRoles = [
  TYPES_USER_ROLES.RELATIVE,
  TYPES_USER_ROLES.STUDENT_UNDER_14,
  TYPES_USER_ROLES.STUDENT,
  TYPES_USER_ROLES.TEACHER,
]

export const indexRoutes = [
  {
    component: lazy(() => import('pages/Classrooms')),
    path: ROUTES.CLASSROOMS,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/JoinClass')),
    path: ROUTES.JOIN_CLASS,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/Evaluations')),
    path: ROUTES.EVALUATIONS,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/BooksResources')),
    path: ROUTES.PREVIOUS_COURSES_BOOKS,
    urlRole: [TYPES_USER_ROLES.STUDENT_UNDER_14, TYPES_USER_ROLES.STUDENT],
  },
  {
    component: lazy(() => import('pages/Students')),
    path: ROUTES.STUDENTS,
    urlRole: [TYPES_USER_ROLES.RELATIVE],
  },
  {
    component: lazy(() => import('pages/UserProfile')),
    path: ROUTES.ACCOUNT,
    urlRole: allRoles,
  },
  {
    component: lazy(() => import('pages/Resources')),
    path: `${ROUTES.BOOKS}${ROUTES.ID_PARAM}${ROUTES.RESOURCES}`,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/ClassroomMarks')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.MARKS}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/ClassroomMaterials')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.BOOKS}`,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/ClassroomStudents')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.STUDENTS}`,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    // WIP: clean fflag enableConfigureEvaluation
    component: lazy(() => import('pages/EvaluationConfigurationDeprecated')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.CONFIGURE_EVALUATIONS}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/StudentProfile')),
    path: `${ROUTES.STUDENTS}${ROUTES.ID_PARAM}`,
    urlRole: [TYPES_USER_ROLES.RELATIVE],
  },
  {
    component: lazy(() => import('pages/PersonalDataChild')),
    path: `${ROUTES.STUDENTS}${ROUTES.ID_PARAM}${ROUTES.EDIT_PERSONAL_DATA_CHILD}`,
    urlRole: [TYPES_USER_ROLES.RELATIVE],
  },
  {
    component: lazy(() => import('pages/BooksResources')),
    path: ROUTES.BOOKS,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/Home')),
    path: ROUTES.HOME,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    // component: lazy(() => import('pages/EvaluationsSteps')),
    component: lazy(() => import('pages/EvaluationsStepsPage')),
    path: `${ROUTES.EVALUATIONS}${ROUTES.ID_PARAM}${ROUTES.STEP}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/EvaluationCreated')),
    path: `${ROUTES.EVALUATIONS}${ROUTES.ID_PARAM}${ROUTES.CREATED}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/Evaluations/NoActivities')),
    path: `${ROUTES.EVALUATIONS}${ROUTES.NO_ACTIVITIES}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/Catalogue')),
    path: ROUTES.CATALOGUE,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/ResetPassword')),
    path: ROUTES.RESET_PASSWORD,
    urlRole: [
      TYPES_USER_ROLES.RELATIVE,
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/SchoolCodeStudent')),
    path: ROUTES.SCHOOL_CODE,
    urlRole: [
      TYPES_USER_ROLES.RELATIVE,
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
    ],
  },
  {
    component: CourseForm,
    path: ROUTES.COURSE,
    urlRole: [
      TYPES_USER_ROLES.RELATIVE,
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
    ],
  },
  {
    component: lazy(() => import('pages/RecoveryPassword')),
    path: ROUTES.RECOVERY_PASSWORD,
    urlRole: [
      TYPES_USER_ROLES.RELATIVE,
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: SelectGroup,
    path: `${ROUTES.SELECT_STUDENT_GROUP}${ROUTES.ID_PARAM}`,
    urlRole: [
      TYPES_USER_ROLES.RELATIVE,
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
    ],
  },
  {
    component: lazy(() => import('pages/ArchivedBooks')),
    path: ROUTES.ARCHIVED_BOOKS,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/EdubookLegalConditions')),
    path: ROUTES.EDUBOOK_LEGAL_CONDITIONS,
    urlRole: allRoles,
  },
  {
    component: lazy(() => import('pages/PublisherLegalConditions')),
    path: ROUTES.PUBLISHER_LEGAL_CONDITIONS,
    urlRole: allRoles,
  },
  {
    component: lazy(() => import('pages/ClassroomTasks')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}`,
    urlRole: [
      TYPES_USER_ROLES.STUDENT_UNDER_14,
      TYPES_USER_ROLES.STUDENT,
      TYPES_USER_ROLES.TEACHER,
    ],
  },
  {
    component: lazy(() => import('pages/CreateTask')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}${ROUTES.CREATE}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/AddActivitiesTask')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}${ROUTES.CREATE}${ROUTES.ADD_ACTIVITIES}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/ActivityView')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}${ROUTES.CREATE}${ROUTES.ADD_ACTIVITIES}${ROUTES.ID_PARAM_2}${ROUTES.VIEW}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/StudentTaskActivityPage')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}${ROUTES.ID_PARAM_2}${ROUTES.STUDENT_MAKE_TASK_ACTIVITIES}`,
    urlRole: [TYPES_USER_ROLES.STUDENT, TYPES_USER_ROLES.STUDENT_UNDER_14],
  },
  {
    component: lazy(() => import('pages/TeacherTaskActivityPage')),
    path: `${ROUTES.CLASSROOMS}${ROUTES.ID_PARAM}${ROUTES.TASKS}${ROUTES.ID_PARAM_2}${ROUTES.SUBMISSIONS}${ROUTES.ID_PARAM_3}${ROUTES.TEACHER_REVIEW_TASK_ACTIVITIES}`,
    urlRole: [TYPES_USER_ROLES.TEACHER],
  },
  {
    component: lazy(() => import('pages/TutorIa')),
    path: ROUTES.TUTOR_IA,
    urlRole: [TYPES_USER_ROLES.STUDENT],
  },
]
